<article class="formEditor">
    @if (hasLabel()) {
        <span class="formLabel">{{ labelText() }}</span>
    }
    <lib-generic-dropdown-multiselect
        [source]="items()"
        [selectedItems]="selectedItems()"
        (selectedItemsChange)="onSelectedItemsChange($event)"
        [config]="{
            defaultText: placeholderText(),
            itemDisplayKey: 'name'
        }"
        [isReadOnly]="isReadOnly()"
    >
    </lib-generic-dropdown-multiselect>
</article>
